"use client";

import React, { useEffect, useState } from "react";
import { Card, Table, Input, Tag, Space, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { getAllCustomerApi } from "../../../redux/api/api";

const { Search } = Input;

const SERVICE_STATUS_COLOR = {
  ACTIVE: "green",
  PENDING: "orange",
  NOT_REGISTERED: "default",
};

const CustomersListTable = () => {
  const [customers, setCustomers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  const getAllCustomers = async () => {
    setLoading(true);
    try {
      const res = await getAllCustomerApi();
      if (res.status === 200) {
        setCustomers(res.data.info || []);
        setFilteredData(res.data.info || []);
      }
    } catch (error) {
      console.error(error);
      message.error(error?.response?.data?.message || "We couldn't load customers right now.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllCustomers();
  }, []);

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = customers.filter(
      (customer) =>
        customer.phone?.toLowerCase().includes(value.toLowerCase()) ||
        customer.globalId?.toLowerCase().includes(value.toLowerCase()) ||
        customer.name?.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Global ID",
      dataIndex: "globalId",
      key: "globalId",
      render: (globalId) => <strong>{globalId}</strong>,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name) => name || "-",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Verified",
      dataIndex: "verified",
      key: "verified",
      render: (verified) => <Tag color={verified ? "green" : "default"}>{verified ? "Yes" : "No"}</Tag>,
    },
    {
      title: "Services",
      dataIndex: "services",
      key: "services",
      render: (services) => (
        <Space wrap>
          {(services || []).length
            ? services.map((s) => (
                <Tag color={SERVICE_STATUS_COLOR[s.status] || "default"} key={s.serviceId}>
                  {s.serviceId}
                </Tag>
              ))
            : <Tag>No services yet</Tag>}
        </Space>
      ),
    },
    {
      title: "Joined",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => (createdAt ? new Date(createdAt).toLocaleDateString() : "-"),
    },
  ];

  return (
    <Card
      bordered={false}
      style={{
        borderRadius: "8px",
        padding: "20px",
        background: "#fff",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <Search
          placeholder="Search by name, phone or global ID..."
          onSearch={handleSearch}
          onChange={(e) => handleSearch(e.target.value)}
          value={searchText}
          prefix={<SearchOutlined />}
          allowClear
          style={{ width: 280 }}
        />
      </div>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={filteredData}
        loading={loading}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} customers`,
        }}
        bordered
      />
    </Card>
  );
};

export default CustomersListTable;
